import React, { useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import profileImage from "../../utils/profile.png";

const UserProfilePopup = ({
  isOpen,
  onClose,
  buttonRef,
  onViewProfile,
  onLogout,
  userData,
}) => {
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        buttonRef &&
        !buttonRef.current?.contains(event.target)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose, buttonRef]);

  const handleViewProfile = () => {
    if (onViewProfile) {
      onViewProfile();
    }
    onClose();
  };

  const handleLogout = () => {
    onLogout?.();
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          ref={popupRef}
          initial={{ opacity: 0, y: -10, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -10, scale: 0.95 }}
          transition={{ duration: 0.2 }}
          className="absolute top-16 right-0 w-80 bg-[#C8D1ED] rounded-lg shadow-2xl z-50 border border-gray-200"
        >
          {/* User Info Section */}
          <div className="p-6 border-b border-gray-300">
            <div className="flex items-start gap-4">
              {/* Profile Picture */}
              <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 border-2 border-white shadow-md">
                <img
                  src={
                    userData?.details?.avatar_url ||
                    userData?.avatar_url ||
                    profileImage
                  }
                  alt={userData?.full_name || "Perfil"}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Name and Title */}
              <div className="flex-1 min-w-0">
                <h3 className="text-xl font-bold text-gray-900 mb-1">
                  {userData?.full_name || "—"}
                </h3>
                <p className="text-sm text-gray-700 font-normal">
                  {userData?.position || userData?.details?.position || "—"}
                </p>
              </div>
            </div>
          </div>

          {/* VER PERFIL Button */}
          <div className="p-4 border-b border-gray-300">
            <button
              onClick={handleViewProfile}
              className="w-full bg-[#222222] text-white font-bold py-3 px-4 rounded hover:bg-[#333333] transition-colors"
            >
              VER PERFIL
            </button>
          </div>

          {/* Cuenta Section */}
          <div className="p-4 border-b border-gray-300">
            <h4 className="text-base font-bold text-gray-900 mb-2">Cuenta</h4>
            <p className="text-sm text-gray-600 font-normal">
              1 mes de Premium por X COP
            </p>
          </div>

          {/* CERRAR SESIÓN Button */}
          <div className="p-4">
            <button
              onClick={handleLogout}
              className="w-full bg-[#3B5998] text-white font-bold py-3 px-4 rounded hover:bg-[#2d4373] transition-colors"
            >
              CERRAR SESIÓN
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UserProfilePopup;
